import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRequest } from './../hooks/useRequest';
import Slider from 'react-slick';
import images from '../assets/images';
import { FiArrowLeft, FiX } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { MY_COMMENT, POST_LIKES_MODAL } from '../context/general/constants';
import { useGeneralDispatch, useGeneralState } from '../context/general/generalContext';
import { getUserInfo } from '../utils/Auth';
import PostLikesModal from '../components/modals/PostLikesModal';

const PostDetail = () => {
  const params = useParams();
  const { id } = params;
  const { request } = useRequest();
  const [post, setPost] = useState();
  const navigate = useNavigate();
  const [likeCount, setLikeCount] = useState([]); // eslint-disable-line no-unused-vars
  const [comment, setComment] = useState([]); // eslint-disable-line no-unused-vars
  const [sendComment, setSendComment] = useState();
  const [page, setPage] = useState(0);
  const [hasNext, setHasNext] = useState(false);
  const { myComment, postLikesModal } = useGeneralState();
  const [sliceEnd, setSliceEnd] = useState(5);
  const dispatch = useGeneralDispatch();
  const [showDelete, setShowDelete] = useState(false);
  const [deletePostIds, setDeletePostIds] = useState();
  const [hasMoreComment, setHasMoreComment] = useState();
  const isOtherScreen = () => {
    return window.innerHeight < 700 ? 0 : 1;
  };

  useEffect(() => {
    if (id) {
      request(`post/getPostDetail?postId=${id}`, {
        method: 'GET'
      }).then((res) => {
        setPost(res?.data?.result);
        setHasMoreComment(res?.data?.result.hasMoreComment);
      });
    }

    request('post/getPostComments', {
      method: 'GET',
      params: {
        postId: id
      }
    }).then((res) => {
      setComment(res.data.result);
      setHasNext(true);
      if (page == 0) {
        dispatch({
          type: MY_COMMENT,
          payload: res.data.result.items.sort((a, b) => b.id - a.id)
        });
      } else {
        dispatch({
          type: MY_COMMENT,
          payload: [...myComment, ...res.data.result.items.sort((a, b) => b.id - a.id)]
        });
      }
    });
  }, [id]);
  const nextPage = () => {
    if (!sliceEnd) {
      setPage(0);
    }
    if (hasNext == true) {
      setPage((prev) => prev + 1);
    }
    setSliceEnd(sliceEnd ? null : 1);
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const showLike = (isPostLike, commentId) => {
    if (isPostLike && post.likeCount < 1) {
      return;
    }
    dispatch({
      type: POST_LIKES_MODAL,
      payload: {
        open: true,
        isPostLike: isPostLike,
        id: id,
        commentId: commentId ? commentId : null
      }
    });
  };
  const sendCommentFunc = () => {
    if (sendComment) {
      request(`post/addComment`, {
        method: 'POST',
        body: {
          postId: id,
          comment: sendComment
        }
      }).then(() => {
        setSendComment('');
        request('post/getPostComments', {
          method: 'GET',
          params: {
            postId: id
          }
        }).then((res) => {
          setComment(res.data.result);
        });
      });
    }
  };

  const likeButton = async (id) => {
    await request('post/likeOrUnlikePost', {
      method: 'POST',
      params: {
        postId: id
      }
    }).then(async () => {
      await request('post/getPostLikes', {
        method: 'GET',
        params: {
          postId: id
        }
      }).then((count) => {
        setLikeCount(count.data.result);
        request(`post/getPostDetail?postId=${id}`, {
          method: 'GET'
        }).then((res) => {
          setPost(res?.data?.result);
        });
      });
    });
  };

  const backtoHome = () => {
    navigate(-1);
  };
  const likeComment = async (comment) => {
    if (id && getUserInfo()?.jti != comment.userId) {
      request(`post/likeOrUnlikeComment?commentId=${comment.id}`, {
        method: 'POST'
      }).then(() => {
        request('post/getPostComments', {
          method: 'GET',
          params: {
            postId: id
          }
        }).then((res) => {
          setComment(res.data.result);
        });
      });
    }
  };
  const setShowDeleteModal = (id) => {
    setDeletePostIds(id);
    setShowDelete(true);
  };
  const deleteComment = (ids) => {
    if (ids) {
      request('post/deleteComment', {
        method: 'DELETE',
        params: {
          commentId: ids
        }
      }).then(async () => {
        request('post/getPostComments', {
          method: 'GET',
          params: {
            postId: id
          }
        }).then((res) => {
          setComment(res.data.result);
          setShowDelete(false);
        });
      });
    }
  };

  return (
    <section className="main-content">
      <div className="container">
        <div className="direction"> {post?.category?.title}</div>
        <div className="post-container">
          <div className="post-container-header">
            <FiArrowLeft size={40} onClick={backtoHome} color="#3ca646" />
            <img className="post-container-header-profile" src={post?.profilePhoto} alt="" />
            <div className="post-container-header-text">{post?.owner}</div>
          </div>
          <div className="post-container-title">
            <h1 className="post-container-title-large">{post?.title}</h1>
          </div>

          {post?.resources?.length > 1 ? (
            <Slider {...settings}>
              {post?.resources?.map((fd, i) => {
                return fd.url.split('.').at(-1) == 'avi' ? (
                  <video controls className="mainpage-cardContainer-card-videoDetail">
                    <source src={fd.url} type="video/mp4" />
                    Your browser does not support HTML5 video.
                  </video>
                ) : (
                  <img
                    key={i}
                    className="mainpage-cardContainer-card-imageDetail"
                    src={fd?.url}
                    alt=""
                  />
                );
              })}
            </Slider>
          ) : post?.resources[0]?.url?.split('.').at(-1) == 'avi' ? (
            <video controls className="mainpage-cardContainer-card-videoDetail">
              <source src={post?.resources[0]?.url} type="video/mp4" />
              Your browser does not support HTML5 video.
            </video>
          ) : (
            <img
              className="mainpage-cardContainer-card-imageDetail"
              src={post?.resources[0]?.url}
              alt=""
            />
          )}

          <div className="post-container-sliderText">
            <div className="post-container-title-bottom">
              <img className="post-container-title-bottom-timer" src={images.iconClock} alt="" />
              <span className="post-container-title-bottom-date">{post?.createdDate}</span>
            </div>
            <p className="post-container-sliderText-top">{post?.description}</p>

            {postLikesModal.open && <PostLikesModal />}
            {showDelete == true ? (
              <div className="post-container-deleteModal">
                <img
                  onClick={() => setShowDelete(false)}
                  className="post-container-deleteModal--close"
                  src={images.iconClose}
                  alt="Close Icon"
                  data-modal-close="data-modal-close"
                />{' '}
                <div className="post-container-deleteModal--content">
                  <div className="post-container-deleteModal-font">
                    Silmek İstediğinize Emin Misiniz?
                  </div>
                  <div className="post-container-deleteModal--buttons">
                    <div
                      className="post-container-deleteModal--buttons--cancel"
                      onClick={() => setShowDelete(false)}>
                      Hayır
                    </div>{' '}
                    <div
                      className="post-container-deleteModal--buttons--ok"
                      onClick={() => deleteComment(deletePostIds)}>
                      Evet
                    </div>
                  </div>
                </div>{' '}
              </div>
            ) : (
              ''
            )}
            <div className="post-container-sliderText-bottom">
              <div className="post-container-sliderText-bottom-like">
                <b onClick={() => likeButton(id)}>
                  {post?.amILiked == true ? 'Beğendin' : ' Beğen'}{' '}
                </b>

                {post?.amILiked == true ? (
                  <AiFillHeart
                    onClick={() => likeButton(id)}
                    className="mainpage-cardContainer-card-dateLikeComment-right-heart"
                    size={16}
                  />
                ) : (
                  <AiOutlineHeart
                    onClick={() => likeButton(id)}
                    className="mainpage-cardContainer-card-dateLikeComment-right-heart"
                    size={16}
                  />
                )}
              </div>
              <div
                className="post-container-sliderText-bottom-count"
                onClick={() => showLike(true)}>
                ({post?.likeCount} Beğeni)
              </div>
            </div>
          </div>
          <hr />
          <div className="post-container-message">
            <div className="post-container-message-top">
              {comment?.length > 0 && (
                <div className="post-container-message-top-left">Yorumlar ({comment?.length})</div>
              )}
            </div>
            {comment?.length > 0 &&
              comment.slice(0, sliceEnd ? sliceEnd : comment.length).map((post, i) => (
                <div key={i} className="post-container-message-card">
                  {' '}
                  {getUserInfo()?.jti == post.userId ? (
                    <FiX
                      size={20}
                      onClick={() => setShowDeleteModal(post.id)}
                      color="#f00000"
                      style={{ position: 'absolute', right: '15%' }}
                    />
                  ) : (
                    ''
                  )}
                  <div className="post-container-message-card-header">
                    <div className="post-container-message-card-header-profile" />{' '}
                    <div className="post-container-message-card-header-text">{post?.owner}</div>
                    {post?.commentLikeCount > 0 && post?.amILiked == true ? (
                      <div
                        style={{ position: 'absolute', right: isOtherScreen == 1 ? '24%' : '22%' }}>
                        {getUserInfo()?.jti != post.userId && (
                          <AiFillHeart
                            className="mainpage-cardContainer-card-dateLikeComment-right-heart"
                            onClick={() => likeComment(post)}
                            size={16}
                          />
                        )}
                      </div>
                    ) : (
                      <div
                        style={{ position: 'absolute', right: isOtherScreen == 1 ? '24%' : '22%' }}>
                        {getUserInfo()?.jti != post.userId && (
                          <AiOutlineHeart
                            className="mainpage-cardContainer-card-dateLikeComment-right-heart"
                            onClick={() => likeComment(post)}
                            size={16}
                          />
                        )}
                      </div>
                    )}{' '}
                    <div
                      onClick={(e) => {
                        post?.commentLikeCount > 0 ? showLike(false, post.id) : e.preventDefault();
                      }}
                      className="post-container-sliderText-bottom-count"
                      style={{ position: 'absolute', right: '17%' }}>
                      ({post?.commentLikeCount} Beğeni)
                    </div>
                  </div>{' '}
                  <div className="post-container-message-card-body">{post?.comment}</div>
                  <div className="post-container-message-card-date">{post?.createdDate}</div>
                </div>
              ))}
            <div className="post-container-message-dot" onClick={nextPage}>
              {comment?.length > 0
                ? (hasMoreComment == page) == 0
                  ? 'Daha Fazla Yorum Göster'
                  : ''
                : comment?.length < 1
                ? 'Lütfen Yorum Yapın'
                : ''}
            </div>
            <div className="post-container-message-input">
              <textarea
                rows={5}
                cols={50}
                placeholder="Yorum Yap"
                defaultValue={''}
                Id="Text"
                value={sendComment}
                onChange={(e) => setSendComment(e.target.value)}></textarea>
              <div className="post-container-message-input-btn" onClick={sendCommentFunc}>
                Gönder
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PostDetail;
